import React from 'react';
import { View, Text, Image, TouchableOpacity, StyleSheet } from 'react-native';
import { useTheme } from '@emotion/react';
import getScreenType from '../../../utils/getScreenType';
import { ODSText } from '../ODSText';

export type PlanFeature = {
    text: string;
};

export type PlanProps = {
    id: string;
    title: string;
    price: string | null;
    priceUnit?: string;
    originalPrice?: string;
    promoLabel?: string;
    features: PlanFeature[];
    image: any; // Image source
    isSelected?: boolean;
    onSelect?: (id: string) => void;
    buttonText?: string;
    buttonColor?: string;
    disabled?: boolean;
    type?: string;
    children?: React.ReactChild;
    onRegistration?: boolean
    hidePrice?: boolean


};

const PlanCard = ({
    id,
    title,
    price,
    priceUnit = '/mo',
    originalPrice,
    promoLabel,
    features,
    image,
    isSelected = false,
    onSelect,
    buttonText = 'Select Plan',
    buttonColor,
    disabled = false,
    type,
    children,
    onRegistration,
    hidePrice
}: PlanProps) => {
    const { colors } = useTheme();


    const layout = getScreenType();

    const buttonBgColor = buttonColor || colors.main.purple;
    const selectedBorderColor = buttonBgColor;

    if (id == 'tlyfe-premium') {
        price = onRegistration ? price : price
    }

    // price = id=='tlyfe-premium'?onRegistration?originalPrice:price;

    return (
        <View
            style={[
                styles.container,
                { borderColor: isSelected ? getItemColor(id).borderColor : 'transparent', backgroundColor: getItemColor(id).bgColor },
                layout === 'phone' ? styles.containerMobile : styles.containerDesktop
            ]}
        >
            <View style={styles.contentContainer}>
                <ODSText type='h5' marginBottom={4} color={colors.text.primary} textAlign='center'>{title}</ODSText>

                {!hidePrice && <View style={styles.priceContainer}>
                    {originalPrice && onRegistration && (
                        <ODSText type='md' textDecorationLine='line-through' marginRight={8} color={colors.text.primary} textAlign='center'>£{originalPrice} / month</ODSText>
                    )}
                    <ODSText type='md' color={colors.text.primary} textAlign='center'>
                        {price ? `£${price} / month` : 'FREE'}
                    </ODSText>
                </View>}

                {!children && promoLabel && onRegistration && (
                    <View style={{ height: 20 }}>
                        <Text style={styles.promoLabel}>{promoLabel}</Text>
                    </View>
                )}


                {!children && <View style={[styles.featuresContainer, { borderWidth: 1, borderColor: getItemColor(id).borderColor }]}>
                    {features.map((feature, index) => (
                        <View key={index} style={styles.featureRow}>
                            <ODSText type='h6' marginRight={8} >•</ODSText>
                            <ODSText type='xs' flex={1}>{feature.text}</ODSText>
                        </View>
                    ))}
                </View>}

                {type != 'single' && <TouchableOpacity
                    style={[
                        styles.button,
                        { backgroundColor: isSelected ? 'transparent' : colors.main[getItemColor(id).btnTheme][500] },
                        isSelected && styles.selectedButton,
                        disabled && styles.disabledButton
                    ]}
                    onPress={() => !disabled && onSelect && onSelect(id)}
                    disabled={disabled || isSelected}
                >
                    <Text
                        style={[
                            styles.buttonText,
                            { color: isSelected ? colors.text.primary : 'white' }
                        ]}
                    >
                        {isSelected ? 'Selected' : buttonText}
                    </Text>
                </TouchableOpacity>}
                {children}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        borderRadius: 12,
        backgroundColor: 'white',
        // overflow: 'hidden',
        borderWidth: 1.5,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
        minWidth: 280,
    },
    containerDesktop: {
        maxWidth: 300,
    },
    containerMobile: {
        // width: '100%',
        // margin: 10

    },
    image: {
        width: '100%',
        height: 120,
        borderTopRightRadius: 12,
        borderTopLeftRadius: 12
    },
    contentContainer: {
        paddingVertical: 24,
        paddingHorizontal: 12
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 8,
    },
    priceContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    price: {
        fontSize: 20,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    originalPrice: {
        fontSize: 16,
        textDecorationLine: 'line-through',
        marginRight: 8,
        color: 'gray',
    },
    promoLabel: {
        fontSize: 12,
        color: 'red',
        fontWeight: 'bold',
        marginTop: 4,
        textAlign: 'center',
    },
    featuresContainer: {
        marginVertical: 12,
        minHeight: 120,
        backgroundColor: 'white',
        padding: 16,
        borderRadius: 12
    },
    featureRow: {
        flexDirection: 'row',
        marginBottom: 0,
        justifyContent: 'center',
        alignItems: 'center',
    },
    bulletPoint: {
        marginRight: 8,
        fontSize: 16,
    },
    featureText: {
        flex: 1,
        fontSize: 14,
    },
    button: {
        borderRadius: 25,
        paddingVertical: 8,
        paddingHorizontal: 16,
        alignItems: 'center',
        justifyContent: 'center',
    },
    selectedButton: {
        borderWidth: 1,
        borderColor: '#ccc',
    },
    disabledButton: {
        opacity: 0.5,
    },
    buttonText: {
        fontSize: 16,
        fontWeight: 'bold',
    },
});

export default PlanCard;

export const itemColors = [{
    id: 'tlyfe-basic',
    bgColor: '#E3F8FA',
    borderColor: '#1FA6B2',
    btnTheme: 'blue'
},
{
    id: 'tlyfe-premium',
    bgColor: '#F3E9FB',
    borderColor: '#A070C4',
    btnTheme: 'purple'
}
    ,
{
    id: 'tlyfe-extra',
    bgColor: '#E3F8FA',
    borderColor: '#EF5D9B',
    btnTheme: 'pink'
}];
export const getItemColor = (id) => {
    const item = itemColors.find((item) => item.id === id);
    return item;
};